<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-14 14:53:11
 * @LastEditTime : 2025-08-08 13:48:56
 * @LastEditors  : yangxr
 * @Description  : 业务记账单明细
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\incomeSheet\incomeSheetDetail.vue
-->
<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <div class="hr"></div>
                    <div class="card">
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" show-summary :summary-method="getSummaries">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width" show-overflow-tooltip :fixed="item.fixed" :prop="item.prop">
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '共享推送'">
                                                <el-button size="mini" class="bottom_one"
                                                    @click="lookPicture(scope.row)">查看详情</el-button>
                                            </span>
                                            <span v-else-if="item.label == '单据编号'">
                                                <el-link :underline="false" type="success"
                                                    @click="GopurchaseSaleStoreDetail(scope.row)">{{ scope.row.code }}</el-link>
                                            </span>
                                            <span v-else-if="item.label == '附件'">
                                                <el-link :underline="false" type="success"
                                                @click="lookFile(scope.row)">查看</el-link>
                                            </span>
                                            <span v-else-if="item.label == '共享状态'">
                                                <span v-if="scope.row.shareStatus == 1">提交共享成功</span>
                                                <span v-if="scope.row.shareStatus == 2">提交共享失败</span>
                                                <span v-if="scope.row.shareStatus == 3">共享审核完成</span>
                                                <span v-if="scope.row.shareStatus == 4">共享审核驳回</span>
                                            </span>
                                            <span v-else-if="item.label == '纸质附件'">
                                                <span v-if="scope.row.paperAttachments == 0">无</span>
                                                <span v-if="scope.row.paperAttachments == 1">有</span>
                                            </span>

                                            <span v-else-if="item.label == '操作'">
                                                <el-button v-if="scope.row.shareStatus == 2 || scope.row.shareStatus == 4" class="bottom_one" size="mini"
                                                    @click="goPurchaseSaleStore(scope.row)">重推</el-button>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <!-- 附件查看 -->
            <el-dialog :visible.sync="fileDig" top="15vh" width="560px" :close-on-click-modal="false">
                <span slot="title" class="dialog-title">附件</span>
                <div>
                    <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
                        stripe :height="screenHeight / 2 - 100" style="width: 100%" :data="fileTableData"
                        tooltip-effect="dark">
                        <el-table-column label="文件名称" prop="name" align="center">
                            <template slot-scope="scope">
                                <span>
                                    <el-link type="sucess" :underline="false" @click="lookFileDetail(scope.row)">{{
                                        scope.row.name }}</el-link>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button class="bottom_all_two" @click="closeFile">关 闭</el-button>
                </span>
            </el-dialog>
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryDetail } from "@/api/docking.js";
export default {
    components: {
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "单据编号", prop: "code", status: true, width: "200" },
                { label: "单据类型", prop: "sheetType", status: true, width: "100" },
                { label: "单据时间", prop: "createTime", status: true, width: "150" },
                { label: "工程名称", prop: "engineeringName", status: true, width: "200" },
                { label: "主体公司", prop: "mainBodyName", status: true, width: "200" },
                { label: "业务大类", prop: "businessType", status: true, width: "150" },
                { label: "业务小类", prop: "businessSmallType", status: true, width: "150" },
                { label: "纸质附件", prop: "paperAttachments", status: true, width: "auto" },
                { label: "备注", prop: "remark", status: true, width: "100" },
                { label: "客户编码", prop: "shareDetailClientName", status: true, width: "150" },
                { label: "关联合同", prop: "shareContractCode", status: true, width: "150" },
                { label: "共享项目编码", prop: "shareProjectCode", status: true, width: "150" },
                { label: "明细客户名称", prop: "shareDetailClientName", status: true, width: "150" },
                { label: "明细客户", prop: "shareDetailClientCode", status: true, width: "150" },
                { label: "金额(含税)", prop: "taxInclusiveAmount", status: true, width: "100" },
                { label: "税额", prop: "money", status: true, width: "100" },
                { label: "账期", prop: "businessTime", status: true, width: "100" },
                { label: "附件", prop: "attachment", status: true, width: "100" },
                { label: "共享状态", prop: "shareStatus", status: true, width: "100" },
                { label: "共享响应", prop: "shareResponse", status: true, width: "100" },
                { label: "共享单据编码", prop: "shareCode", status: true, width: "200" },
                { label: "操作", prop: "productionSite", status: true, width: "100", fixed: 'right' },
            ],
            tableData: [],
            pagesType: 0,
            tableParams: {
                sheetId: "",//筛选条件：主体
            },
            mainBodyList: [],
            fileTableData: [],
            fileDig: false,
        };
    },
    watch: {
    },
    async created() {
        const query = this.$route.query
        this.tableParams.sheetId = query.id
        this.queryDetail();
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (index == 1 && index== 2 && index == 3&& index == 4) {
                    sums[index] = '';
                    return
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value)) && (index == 14 || index ==15)) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return (Number(prev) + Number(curr)).toFixed(2);
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        GopurchaseSaleStoreDetail(row){
            console.log(row)
            this.$router.push({name:'saleMonthReportDetail',query:{code:row.id,isIcps:true}})
        },
        goPurchaseSaleStore(row){
            console.log(row)
            this.$router.push({name:'saleMonthReport',query:{mainBodyId:row.mainBodyId,mainBodyName:row.mainBodyName,businessTime:row.businessTime}})
        },
        closeFile() {
            this.fileDig = false
        },
        lookFile(row) {
            let file = []
            if (!row.attachment) {
                this.$message.warning('暂无附件！')
                return
            }
            file = JSON.parse(row.attachment)
            this.fileTableData = file
            this.fileDig = true
        },
        lookFileDetail(row) {
            window.open(row.url, "_blank");
        },
        queryDetail() {
            queryDetail(this.tableParams).then(res => {
                this.tableData = res.data
            })
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}
</style>
  